module.exports = __webpack_public_path__ + "static/img/jianjiePic.ba27c038.png";